import { Controller } from "@hotwired/stimulus"
import "../oi.hexmap.js"

export default class extends Controller {

  connect() {
    console.log("hexmap#connect");

    function makePattern(id) {
      return `
        <pattern id="${id}" width="100%" height="100%" patternUnits="objectBoundingBox">
          <image 
            href="https://map.hextonhills.com/hexSets/hexton-hills/tiles/${id.toUpperCase()}.png" 
            x="0" y="0" 
            width="120"
            preserveAspectRatio="xMidYMid slice"
          />
        </pattern>`;
    }

    const patternIds = [
      'ao01', 'ao02', 'ao03',
      'ah01', 'ah02', 'ah03', 'ah04', 'ah05', 'ah06',
      'ap01', 'ap02', 'ap03', 'ap04', 'ap05', 'ap06',
      'al01', 'al02', 'al03', 'al04', 'al05', 'al06',
      'am01', 'am02', 'am03', 'am04', 'am05', 'am06', 'am07', 'am08', 'am09', 'am10',
      'ac01', 'ac02', 'ac03', 'ac04', 'ac05', 'ac06',
      'aw01', 'aw02', 'aw03', 'aw04', 'aw05', 
      'av01', 'av02', 'av03', 'av04', 'av05', 'av06', 'av07', 'av08', 'av09', 'av10', 'av11'
    ];

    const url = this.element.dataset.hexgridUrl;
    const showLabel = this.element.dataset.showLabel == "true";
    console.log(showLabel);
    fetch(url)
      .then(response => {
        if (!response.ok) throw new Error("Netzwerkfehler");
        return response.json();
      })
      .then(hexJson => {
        const hex = new OI.hexmap(this.element, {
          'grid': { 'show': false },
          'hexjson': {
            'layout': 'odd-q',
            'hexes': hexJson
          },
          'patterns': patternIds.map(id => makePattern(id)),
          'label': {
            'show': showLabel,
            'clip': true
          },
          'ready': function() {}
        });
      })
      .catch(error => {
        console.error("Fehler beim Laden des JSON:", error);
      });

  };
}
